export default __webpack_public_path__ + "static/media/company_logo.add622d3.png";